import { render, staticRenderFns } from "./BarButtons.vue?vue&type=template&id=994e7ce2&scoped=true"
import script from "./BarButtons.vue?vue&type=script&lang=js"
export * from "./BarButtons.vue?vue&type=script&lang=js"
import style0 from "./BarButtons.vue?vue&type=style&index=0&id=994e7ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994e7ce2",
  null
  
)

export default component.exports